import { Typography } from "@/components/ui/typography";
import { WhyItem } from "./why-item";
import { OneIcon } from "@/icons/one";
import { HandshakeIcon } from "@/icons/handshake";
import { BoltIcon } from "@/icons/bolt";
import { CrownIcon } from "@/icons/crown";

const Why = () => {
  return (
    <div className="flex flex-col gap-16 items-center w-full">
      <div>
        <div className="flex gap-3 items-center justify-center">
          <Typography variant={"title"}>ЯАГААД</Typography>
          <Typography variant={"title"} className="text-primary">
            PLUS
          </Typography>
          <Typography variant={"title"}>ГЭЖ?</Typography>
        </div>
        <Typography className="text-center">
          БИД ЦОРЫН ГАНЦ, ХАМГИЙН ХЯМД, ХАМГИЙН ХУРДАН 
        </Typography>
      </div>
      <div className="flex gap-5 lg:items-center justify-between w-full h-full max-sm:flex-col">
        {list.map((item, index) => (
          <WhyItem key={index} item={item} />
        ))}
      </div>
    </div>
  );
};
export default Why;

const list = [
  {
    icon: <OneIcon />,
    title: "МОНГОЛД ЦОРЫН ГАНЦ",
    description:
      "Бид Монголын хамгийн том, хамгийн олон төрлийн GIVEAWAY өгдөг COMMUNITY.",
  },
  {
    icon: <BoltIcon />,
    title: "CRYPTO БОЛОН FOREX АРИЛЖААНЫ СИГНАЛ",
    description:
      "Ашигтай арилжаачин болох боломжийг манай хаалттай telegram group танд хурдан бөгөөд ойлгомжтой аргаар хүргэх болно.",
  },
  {
    icon: <CrownIcon />,
    title: "ТУРШЛАГАТАЙ",
    description:
      "Манай баг арилжаа, social media салбаруудад 5+ жил тасралтгүй ажилласан туршлагатай.",
  },
  {
    icon: <HandshakeIcon />,
    title: "ТУСЛАМЖ",
    description: "Манай мэргэжлилйн хамт олон таньд туслахад үргэлж бэлэн.",
  },
];
